import { Accordion, Col, Nav, Row, Tab, Container } from "react-bootstrap";
import classes from "./styles.module.scss";
import clsx from "classnames";
import ArrowRight from "@/assets/ArrowRight.svg";
import { useMediaQuery } from "@react-hook/media-query";
import { useEffect, useState } from "react";
import { Heading } from "@/ui/Heading";
import Image from "@/ui/Image";

export const MiniTabs = ({ className, title, content, items, variant }) => {
  const breakpoint = useMediaQuery("only screen and (min-width: 1200px)");
  const [isMobile, setMobile] = useState(null);

  useEffect(() => {
    setMobile(!breakpoint);
  }, [breakpoint]);
  return (
    <div className={clsx(className, classes.tabs, `variant-${variant}`)}>
      <Container>
        <Heading>
          <h2>{title}</h2>
        </Heading>
        <div className="mb-5" dangerouslySetInnerHTML={{ __html: content }} />
        <div className="text-overlay__content ms-0 ms-md-4">
          <div className="position-relative" style={{ zIndex: 2 }}>
            {isMobile ? (
              items.map((i, k) => (
                <Accordion id={`${i}_${k}`} key={k} className="mx-md-5">
                  <Accordion.Item eventKey={k}>
                    <Accordion.Header>
                      {i.title}
                      <i className="flex-shrink-0">
                        <ArrowRight />
                      </i>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      <div dangerouslySetInnerHTML={{ __html: i.text }} />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              ))
            ) : (
              <Tab.Container defaultActiveKey={0}>
                <Row>
                  <Col xs={12} sm={6} className="px-sm-0">
                    <Nav variant="pills" className="flex-column">
                      {items.map((i, k) => (
                        <Nav.Item key={k}>
                          <Nav.Link eventKey={k} className="p-3">
                            {i.title}
                            <i>
                              <ArrowRight />
                            </i>
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Col>
                  <Col xs={12} sm={6} className="px-sm-0">
                    <Tab.Content>
                      {items.map((i, k) => (
                        <Tab.Pane key={k} eventKey={k}>
                          <div className="p-4" dangerouslySetInnerHTML={{ __html: i.text }} />
                        </Tab.Pane>
                      ))}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            )}
          </div>

          <Image
            className="text-overlay__background"
            img={{
              path: "page.service.deliver.section-1.bg",
              src: "/assets/grid/bg.png",
            }}
            size="x650"
            alt=""
          />
        </div>
      </Container>
    </div>
  );
};

export default MiniTabs;
